<template>
    <div>
        <v-divider class="azul" />
        <v-footer light padless class="mt-4">
            <v-card class="flex" flat tile>
                <!-- Escondido hasta que pasen las redes
                <v-card-title>
                    <strong class="subheading azul--text">
                        Contactate con nosotros mediante nuestras redes sociales
                        !
                    </strong>
                    <v-spacer />
                    <v-btn
                        v-for="(item, index) in items"
                        :key="index"
                        class="mx-4"
                        icon
                    >
                        <a :href="item.url" target="_blank">
                            <v-icon color="azul" size="24px">
                                {{ item.icon }}
                            </v-icon>
                        </a>
                    </v-btn>
                </v-card-title>
-->
                <v-card-text id="company" class="pt-0 azul--text text-center">
                    <strong>
                        {{ empresa }}
                    </strong>
                </v-card-text>

                <v-card-text class="pb-2 pt-0 azul--text text-center">
                    &copy;
                    {{ currentYear }}
                    -
                    {{ productedby }}
                </v-card-text>
            </v-card>
        </v-footer>
    </div>
</template>

<script>
export default {
    data: () => ({
        items: [
            {
                icon: 'mdi-whatsapp',
                url: '#'
            },
            {
                icon: 'mdi-twitter',
                url: '#'
            },
            {
                icon: 'mdi-linkedin',
                url: '#'
            },
            {
                icon: 'mdi-instagram',
                url: '#'
            }
        ],
        productedby: 'The Chad Coders',
        empresa: 'Drogueria Ciafarma'
    }),

    computed: {
        currentYear() {
            return new Date().getFullYear();
        }
    }
};
</script>
<style>
a {
    text-decoration: none;
}
#company {
    font-size: 1.4rem;
}
</style>
